export default __webpack_public_path__ + "static/media/download-blue.cebb3c76.svg";